import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WaterIcon from "@mui/icons-material/Water";
import gallery1 from "../../../assets/projects/nip.jpg";
import gallery2 from "../../../assets/projects/nip_2.jpg";
import gallery3 from "../../../assets/projects/nip_3.jpg";
import gallery4 from "../../../assets/projects/nip_4.jpg";
import gallery5 from "../../../assets/projects/nip_5.jpg";
import gallery6 from "../../../assets/projects/nip_6.jpg";
import gallery7 from "../../../assets/projects/nip_7.jpg";
import gallery8 from "../../../assets/projects/nip_8.jpg";

const Gallery = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
  ];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box padding={{ xs: "10% 0%", sm: "4% 0%" }}>
      <Box>
        <Box>
          <Typography
            variant="h6"
            color="#9DCC49"
            fontWeight={800}
            paddingTop={"9%"}
            paddingBottom={"2%"}
            textAlign={"left"}
          >
            <Box component={"span"}>
              <WaterIcon
                sx={{
                  width: 23,
                  height: 23,
                }}
              />
            </Box>{" "}
            Our Photo Gallery
          </Typography>
        </Box>
      </Box>
      <Box marginTop={{ xs: "5%", sm: "2%" }}>
        {photosToShow.map((item, index) => (
          <Box
            component="img"
            height={{ xs: "27vh", sm: "200px" }}
            onClick={() => {
              setCurrentImageIndex(index);
              setIsViewerOpen(!isViewerOpen);
            }}
            sx={{
              cursor: "pointer",
              objectFit: "cover",
            }}
            src={item}
            alt={"nip_img"}
            marginRight={{ xs: "0%", sm: "0.5%" }}
            marginBottom={{ xs: "1%", sm: "0.5%" }}
            width={{ xs: "100%", sm: "23%" }}
          />
        ))}

        <FsLightbox
          toggler={isViewerOpen}
          sources={photos}
          slide={currentImageIndex + 1}
        />
      </Box>
    </Box>
  );
};

export default Gallery;
